/**
 * Assessment ids that code outside the Assessment tab needs to name.
 *
 * ⚠️ These are DB primary keys (seeded), not display names — see
 * `display-name-is-a-storage-key`. A rename anywhere in the UI must never touch
 * them.
 *
 * ⚠️ `LIFE_MAP_ID` lives in `constants/lifeMap.ts` beside the rest of the Life
 * Map's model; it is re-exported here so "which assessment?" has one place to
 * look.
 */

export { LIFE_MAP_ID } from './lifeMap';

/**
 * The Talent assessment — the Growth Module's step 14.
 *
 * ⭐ Promoted out of a local const inside `assessmentStore.getTalentContext`,
 * which was the only thing that knew this id.
 */
export const TALENT_ASSESSMENT_ID = 'a1000000-0000-0000-0000-000000000001';

/**
 * The ten assessments the Calibration module walks through, one step each
 * (`docs/CALIBRATION_MODULE_SPEC.md` §4).
 *
 * ⚠️ Several are also exported beside their own data (`ARCHETYPE_ID` in
 * `data/archetypes.ts`, `MIND_ID`, `SHADOW_ID`…). They are repeated here rather
 * than imported because those modules carry the whole question bank, and the
 * Growth Journey constants must not pull a question bank into every page that
 * renders the Roadmap. A test pins each pair equal.
 */
export const NORTH_STAR_ASSESSMENT_ID = 'a1000000-0000-0000-0000-000000000017';
export const LIFE_BALANCE_ASSESSMENT_ID = 'a1000000-0000-0000-0000-000000000010';
export const ENERGETIC_ASSESSMENT_ID = 'a1000000-0000-0000-0000-000000000014';
export const MIND_ASSESSMENT_ID = 'a1000000-0000-0000-0000-000000000016';
export const JOB_ROLE_ASSESSMENT_ID = 'a1000000-0000-0000-0000-000000000011';
export const CAREER_ASSESSMENT_ID = 'a1000000-0000-0000-0000-000000000006';
export const PERSONALITY_ASSESSMENT_ID = 'a1000000-0000-0000-0000-000000000012';
export const ARCHETYPE_ASSESSMENT_ID = 'a1000000-0000-0000-0000-000000000015';
export const SHADOW_ASSESSMENT_ID = 'a1000000-0000-0000-0000-000000000013';
export const GROWTH_MATURITY_ASSESSMENT_ID = 'a1000000-0000-0000-0000-000000000005';
